import {BaseDocument, BaseRepository, FieldFunctions} from "./repository";
import firebase from "firebase/compat";
import _firestore from "@google-cloud/firestore";


export interface Token extends BaseDocument<Token> {
  token: string;
  expiresAt: number;
}

export class TokenRepository extends BaseRepository<Token> {

  constructor(firestore: firebase.firestore.Firestore | _firestore.Firestore, fieldFunctions?: FieldFunctions) {
    super(firestore, 'tokens', fieldFunctions);
  }
  public async findByToken(token: string): Promise<Token | null> {
    const results = await this.find({
      where: [{ field: 'token', operator: '==', value: token }],
    });

    return this.firstOrNull(results);
  }
}